export default "__VITE_ASSET__6406bca8__"